import MySetting from './container/index';

export default MySetting;


// WEBPACK FOOTER //
// ./src/views/MySetting/index.js